module.exports = __webpack_public_path__ + "static/media/pores_nose.41c445a3.svg";